import axios from 'axios';

export const SUBSCRIPTION_API = axios.create({
    baseURL: process.env.REACT_APP_COMMUNICATIONS_API_URL + 'subscriptions/'
});

